// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ipv6-address-input-input--261uPtykiH4WPea3e0L7Kz{height:30px !important;width:60% !important}.ipv6-address-input-error--3nHHCT5e9Vuu6Oq15pVc7n{border:1px solid red !important}", "",{"version":3,"sources":["webpack://src/components/common/IPv6AddressInput/ipv6AddressInput.module.scss"],"names":[],"mappings":"AAAA,kDACC,sBAAA,CACA,oBAAA,CAED,kDACC,+BAAA","sourcesContent":[".input {\r\n\theight: 30px !important;\r\n\twidth: 60% !important;\r\n}\r\n.error {\r\n\tborder: 1px solid red !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "ipv6-address-input-input--261uPtykiH4WPea3e0L7Kz",
	"error": "ipv6-address-input-error--3nHHCT5e9Vuu6Oq15pVc7n"
};
export default ___CSS_LOADER_EXPORT___;
